@if (
  (userStore.initialized() && userStore.isLoggedIn()) ||
  userStore.context() === 'atlasExternal'
) {
  <app-authenticated-atlas></app-authenticated-atlas>
}
